/**
 * Desktop auth/bootstrap updates happen in the Electron main process, outside
 * the SPA's root beforeLoad lifecycle. Reload so the renderer re-reads the
 * current bridge envelope, auth gate, and primary environment from scratch.
 */
export function reloadDesktopRendererAfterBridgeUpdate(): void {
  if (typeof window === "undefined") {
    return;
  }
  window.location.reload();
}
